import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../theme';

export default StyleSheet.create({
  container: {
    backgroundColor: colorPalette.grey0_5,
    borderRadius: 12,
    flexDirection: 'row',
    paddingVertical: 12,
    paddingHorizontal: 12,
    alignItems: 'center',
  },
  priceWrapper: {
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
  },
  price: {
    fontFamily: textStyles.bold,
    fontSize: 16,
    color: colorPalette.grey9,
  },
  priceUnit: {
    fontFamily: textStyles.regular,
    fontSize: 14,
    color: colorPalette.grey7,
  },
  centerItem: {
    alignSelf: 'center',
  },
  infoWrapper: {
    flex: 1,
    alignSelf: 'stretch',
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingLeft: 8,
  },
  name: {
    fontSize: 16,
    fontFamily: textStyles.bold,
    color: colorPalette.grey9,
    flexShrink: 1,
    textAlign: 'right',
  },
});
